import { useEffect, useRef, useState, useMemo } from "react";
import { Col, Row, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Services from "../../API/services";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Layout from "../../layout";
import { useDownloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import ReactGA from "react-ga4";
import { showPrice } from "utils/utils";
import { mainUrl } from "API/client/api";

let foodTax = 2.5;
const STORY_HEADERS = [
  {
    prop: "SN",
    title: "SN.",
    cell: (row, ) => row.SN,
    // isSortable: false,
    // isFilterable: false,
  },
  {
    prop: "id",
    title: "Payment ID",
    cell: (row) => `${row?.response?.id ?? "N/A"}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "bookingId",
    title: "Booking ID",
    cell: (row) => `${row?.BookingHotel?.bookingCode ? row?.BookingHotel?.bookingCode : '-'}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "name",
    title: "Guest Name",
    cell: (row) => `${row?.BookingHotel?.User?.name ? row?.BookingHotel?.User?.name : '-'}`,
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "name",
    title: "Property Name",
    cell: (row) => `${row?.BookingHotel?.PropertyMaster?.name ? row?.BookingHotel?.PropertyMaster?.name : '-'}`,
    // isFilterable: true,
    // isSortable: true,
  },

  {
    prop: "name",
    title: "Check-In Date",
    cell: (row) => moment(row?.BookingHotel?.fromDate).format('DD-MM-YYYY')
    // isFilterable: true,
    // isSortable: true,
  },
  
  {
    prop: "name",
    title: "Check-Out Date",
    cell: (row) => moment(row?.BookingHotel?.toDate).format('DD-MM-YYYY')
    // isFilterable: true,
    // isSortable: true,
  },

  {
    prop: "name",
    title: "Booking Date",
    cell: (row) => moment(row?.BookingHotel?.createdAt).format('DD-MM-YYYY HH:mm')
    // isFilterable: true,
    // isSortable: true,
  },
  {
    prop: "paymentDateTime",
    title: "Payment Status",
    // isSortable: true,
    // isFilterable: true,
    cell: (row) => row.status == 1 && "Fail" || row.status == 2 && "Paid",
  },

  {
    prop: "amount",
    title: "Payment Mode",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row.response.method ? row.response.method : '-'
  },

  {
    prop: "amount",
    title: "Total Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row.BookingHotel?.bookingAmout
  },

  {
    prop: "amount",
    title: "Paid Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row.amount
  },
  {
    prop: "amount",
    title: "Balance Amount",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => row.BookingHotel.dueAmount
  },
  

  {
    prop: "paymentAmount",
    title: "Payment Date",
    // isFilterable: true,
    // isSortable: true,
    cell: (row) => moment(row.createdAt).format('DD-MM-YYYY HH:mm')
  },

];

// Then, use it in a component.
export default function NewTransactionReport() {

  const { userDetail } = useSelector(authenticationSeletor);
  const [tableData, setTableData] = useState([]);
  const [exportFilter, setExportFilter] = useState({
    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 1);
      return d;
    })(),
    endDate: new Date(),
  });
  const [searchBookingId, setSearchBookingId] = useState('');
  const [searchOutletId, setSearchOutletId] = useState('');
  const [debouncedBookingId, setDebouncedBookingId] = useState('');
  const [debouncedOutletId, setDebouncedOutletId] = useState('');

  const tableRef = useRef();
  const { access_token } = useSelector((state) => state.authentication);


  const getDataHandler = async () => {
    const payload = {
      fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
      todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
    };
    if (searchBookingId) {
      payload.bookingCode = searchBookingId
    }
    if (searchOutletId) {
      payload.merchantTransactionId = searchOutletId
    }
    try {
      const res = await Services.property.transactionReport(payload)
      if (res.status === 200) {
        const resultWithSN = res.data.data.map((item, index) => ({
          ...item,
          SN: index + 1,
        }));
        setTableData(resultWithSN);
      }
    } catch (error) { }
  };


  useEffect(() => {
    getDataHandler();
  }, [exportFilter.startDate, exportFilter.endDate, debouncedBookingId, debouncedOutletId])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedBookingId(searchBookingId);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchBookingId]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedOutletId(searchOutletId);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchOutletId]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "food_reporting" });
  }, []);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Food_Orders_Details",
    sheet: "Food_Orders_Details",
  });


  const exportHandler = async () => {
    const payload = {
      fromdate: moment(exportFilter.startDate).format("YYYY-MM-DD 00:00:00"),
      todate: moment(exportFilter.endDate).format("YYYY-MM-DD 23:59:59"),
      propertyId: userDetail?.propertyId,
    };
    if (searchBookingId) {
      payload.bookingCode = searchBookingId;
    }
    if (searchOutletId) {
      payload.merchantTransactionId = searchOutletId;
    }

    fetch(`${mainUrl}api/rrooms-property/transaction-report-export`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${access_token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Transaction-Report.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      });
  };

  const [parsedData, setParsedData] = useState([]);

  useEffect(() => {
    if (tableData?.length) {
      const updatedData = tableData.map((item) => ({
        ...item,
        request: JSON.parse(item.request),
        response: JSON.parse(item.response),
      }));
      setParsedData(updatedData);
    }
  }, [tableData]); // 👈 Dependency


  return (
    <Layout
      title="Food Report"
      extraBtnHandler={exportHandler}
      extraButton="Export Table"
      setFromDate={(date) =>
        setExportFilter({ ...exportFilter, startDate: date })
      }
      searchfilter={true}
      setToDate={(date) => setExportFilter({ ...exportFilter, endDate: date })}
      dateFilter={exportFilter}
      searchType={"date"}
      fromDate={exportFilter.startDate}
      toDate={exportFilter.endDate}
    >
      <Row className="justify-content-end">
        <DatatableWrapper
          body={parsedData}
          headers={STORY_HEADERS}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 20,
              options: [5, 10, 15, 20, 50, 100, 300],
            },
          }}
          defaultSortProp="" // ✅ No default sorting
          defaultSortOrder="asc" // optional, required if library complains
        >
          <div className="col-lg-8 mb-2">
            <div className="row-sm d-flex justify-content-end">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="field-control sm border-dark"
                  value={searchBookingId}
                  onChange={(e) => {
                    setSearchBookingId(e.target.value);
                    setSearchOutletId('')
                  }}
                  placeholder="Search By Booking Code" />
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="field-control sm border-dark"
                  value={searchOutletId}
                  onChange={(e) => {
                    setSearchOutletId(e.target.value);
                    setSearchBookingId('')
                  }}
                  placeholder="Search By Transaction Id" />
              </div>
              <div className="col-lg-1">
                <PaginationOptions />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <Table className="food-report" ref={tableRef}>
              <TableHeader />
              <TableBody />
            </Table>
          </div>
          <Col className="d-flex flex-col justify-content-end align-items-end paginationFoodReport">
            <Pagination />
          </Col>
        </DatatableWrapper>
      </Row>

    </Layout>
  );
}
